import type { ReactNode } from 'react';

/**
 * The top of every screen: what you are looking at, why, and the one action that belongs here.
 *
 * A component rather than a copied heading because the description is not decoration — most of
 * these screens configure something whose consequences are not obvious from its name, and a
 * sentence at the top is cheaper than a support call.
 */
export function PageHeader({
  title,
  description,
  actions,
}: {
  readonly title: string;
  readonly description?: string;
  readonly actions?: ReactNode;
}) {
  return (
    <header className="page-header">
      <div>
        <h1>{title}</h1>
        {description ? <p className="page-header__description">{description}</p> : null}
      </div>
      {actions ? <div className="page-header__actions">{actions}</div> : null}
    </header>
  );
}
